import React, { useContext } from 'react';
import Context from '../../../../utils/context';
import { isFeatureEnabled, accountFromConversationSurvey, FEATURES } from '../../../../helpers/feature_checker';
import Legacy from './index.jsx';
import V2 from './v2.jsx';

export default function BylvayPostConversationSurveyGated(props) {
  const ctx = useContext(Context);
  const authAccount = ctx?.auth?.currentAccount ? ctx.auth.currentAccount() : null;
  const account = authAccount || accountFromConversationSurvey(props.conversationSurvey);
  return isFeatureEnabled(account, FEATURES.NEW_UI) ? <V2 {...props} /> : <Legacy {...props} />;
}
